var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"coffee-cta",attrs:{"href":this.location,"color":_vm.color,"rounded":"","target":"_blank","fixed":"","bottom":"","right":""}},[_vm._v(" "+_vm._s(this.text)+" "),_c('v-icon',{attrs:{"right":"","large":""}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }